import { createSlice } from "@reduxjs/toolkit";
import { revertAll } from "../revertAll/RevertStateReducer";

const initialState = {
  list: [],
  pagination: { page: 1, pageSize: 10, totalItems: 0, totalPages: 1 },
  listLoading: false,
  listError: null,

  addLoading: false,
  addError: null,

  editLoading: false,
  editError: null,

  deleteLoading: false,
  deleteError: null,
};

const supplierSlice = createSlice({
  name: "supplier",
  initialState,
  extraReducers: (builder) => builder.addCase(revertAll, () => initialState),
  reducers: {
    fetchSuppliersStart(state) {
      state.listLoading = true;
      state.listError = null;
    },
    fetchSuppliersSuccess(state, action) {
      state.listLoading = false;
      state.list = action.payload.list;
      state.pagination = action.payload.pagination;
    },
    fetchSuppliersFailure(state, action) {
      state.listLoading = false;
      state.listError = action.payload;
    },

    addSupplierStart(state) {
      state.addLoading = true;
      state.addError = null;
    },
    addSupplierSuccess(state) {
      state.addLoading = false;
    },
    addSupplierFailure(state, action) {
      state.addLoading = false;
      state.addError = action.payload;
    },

    editSupplierStart(state) {
      state.editLoading = true;
      state.editError = null;
    },
    editSupplierSuccess(state) {
      state.editLoading = false;
    },
    editSupplierFailure(state, action) {
      state.editLoading = false;
      state.editError = action.payload;
    },

    deleteSuppliersStart(state) {
      state.deleteLoading = true;
      state.deleteError = null;
    },
    deleteSuppliersSuccess(state) {
      state.deleteLoading = false;
    },
    deleteSuppliersFailure(state, action) {
      state.deleteLoading = false;
      state.deleteError = action.payload;
    },
  },
});

export const {
  fetchSuppliersStart,
  fetchSuppliersSuccess,
  fetchSuppliersFailure,
  addSupplierStart,
  addSupplierSuccess,
  addSupplierFailure,
  editSupplierStart,
  editSupplierSuccess,
  editSupplierFailure,
  deleteSuppliersStart,
  deleteSuppliersSuccess,
  deleteSuppliersFailure,
} = supplierSlice.actions;

export default supplierSlice.reducer;